import { WDD } from '../core/wdd.js';

export function headerAnim() {
    const backup = () => {
        WDD.el?.querySelector('.bp-header--root')?.classList.add('bp-header--animate_2');
    };
	const root = WDD.el?.querySelector('.bp-header--root');
	if (!root) return backup();

	const backgroundPhones = Array.from(root.querySelectorAll('.bp-header__background .bp-header__background-phone'));
	const firstPhone = backgroundPhones[0];
	const firstImage = firstPhone?.querySelector('img');

	if (!firstImage) return backup();

	const animationClasses = [
		'bp-header--animate_1',
		'bp-header--animate_2',
		'bp-header--animate_3',
		'bp-header--animate_4',
		'bp-header--animate_5',
		'bp-header--animate_6',
	];

	const setAnimationStage = stage => {
		root.classList.remove(...animationClasses);
		root.classList.add(`bp-header--animate_${stage}`);
	};

	const waitForImageReady = image => new Promise(resolve => {
		const finish = () => {
			if (typeof image.decode === 'function') {
				image.decode().catch(() => {}).finally(resolve);
				return;
			}

			resolve();
		};

		if (image.complete && image.naturalWidth > 0) {
			finish();
			return;
		}

		const onLoad = () => {
			cleanup();
			finish();
		};

		const onError = () => {
			cleanup();
			resolve();
		};

		const cleanup = () => {
			image.removeEventListener('load', onLoad);
			image.removeEventListener('error', onError);
		};

		image.addEventListener('load', onLoad, { once: true });
		image.addEventListener('error', onError, { once: true });

		if (image.complete && image.naturalWidth > 0) {
			cleanup();
			finish();
		}
	});

	const sequence = [
		[3, 8000],
		[4, 1000],
		[5, 8000],
		[6, 1000],
		[1, 8000],
		[2, 1000],
	];
	const initialStageClass = animationClasses.find(className => root.classList.contains(className));
	const initialStage = Number(initialStageClass?.match(/\d+$/)?.[0]);
	const initialSequenceIndex = sequence.findIndex(([stage]) => stage === initialStage);

	let timerId = null;

	const runSequence = index => {
		const [stage, delay] = sequence[index];

		timerId = window.setTimeout(() => {
			setAnimationStage(stage);
			runSequence((index + 1) % sequence.length);
		}, delay);
	};

	waitForImageReady(firstImage).then(() => {
		if (timerId) window.clearTimeout(timerId);
		runSequence(initialSequenceIndex >= 0 ? (initialSequenceIndex + 1) % sequence.length : 0);
	});
}